/*
 * @Author: wangshengqiang
 * @Date: 2021-12-28 10:07:13
 * @LastEditTime: 2022-01-09 15:29:00
 * @LastEditors: wangshengqiang
 * @Description: 证件附件上传
 */
import React, { useEffect, useState } from 'react';
import { FileUpload } from '@/baseComponents';
import FormItem from '@/baseComponents/FormItem';
import { getPreLeveFormKey } from '@/utils/utils';
import { useStore } from '@/store/';
import './index.less';

const CertAttachmentUpload = ({
  value,
  onChange,
  isIDCard = true
}) => {
  const [list, setList] = useState([]);

  const handleOnChange = (imgSrc, index) => {
    const nList = [...list];
    nList[index] = imgSrc;
    onChange(nList);
  };

  useEffect(() => {
    if (value) {
      setList(value);
    }
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "cert-attachment"
  }, isIDCard && /*#__PURE__*/React.createElement("div", {
    className: "img-upload-item"
  }, /*#__PURE__*/React.createElement(FileUpload, {
    value: list[0],
    onChange: val => {
      handleOnChange(val, 0);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "uplaod-btn-con bg-card-front"
  }, list[0] && /*#__PURE__*/React.createElement("img", {
    className: "img-previe",
    src: list[0],
    alt: "233"
  })))), isIDCard && /*#__PURE__*/React.createElement("div", {
    className: "img-upload-item "
  }, /*#__PURE__*/React.createElement(FileUpload, {
    value: list[1],
    onChange: val => {
      handleOnChange(val, 1);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "uplaod-btn-con bg-card-back"
  }, list[1] && /*#__PURE__*/React.createElement("img", {
    className: "img-previe",
    src: list[1],
    alt: "233"
  })))), !isIDCard && /*#__PURE__*/React.createElement("div", {
    className: "img-upload-item bg-card"
  }, /*#__PURE__*/React.createElement(FileUpload, {
    onChange: val => {
      handleOnChange(val, 0);
    },
    value: list[0]
  }, /*#__PURE__*/React.createElement("div", {
    className: "uplaod-btn-con bg-card"
  }, list[0] && /*#__PURE__*/React.createElement("img", {
    className: "img-previe",
    src: list[0],
    alt: "233"
  })))));
};

const CertAttachment = props => {
  const {
    formKey,
    label
  } = props;
  const formKeyPrefix = getPreLeveFormKey(formKey);
  const certType = useStore(`formValues.${formKeyPrefix}.certType`);
  const formItemProps = {
    // label, // title,
    name: formKey,
    // formKey,
    isShow: true,
    newline: true,
    fieldOption: {// rules: finalRules,
      // isBenefitFactor,
      // isPremiumFactor,
      // validateTrigger,
      // initialValue,
    }
  };
  return /*#__PURE__*/React.createElement(FormItem, formItemProps, /*#__PURE__*/React.createElement(CertAttachmentUpload, {
    isIDCard: certType === 'I'
  }));
};

export default CertAttachment;